import { computed, ref } from 'vue';
import SessionStorage from 'shared/helpers/sessionStorage';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/sessionStorage';

const impersonationSession = ref(
  SessionStorage.get(SESSION_STORAGE_KEYS.IMPERSONATION_USER)
);

export function setImpersonationSession(session) {
  impersonationSession.value = session;
  SessionStorage.set(SESSION_STORAGE_KEYS.IMPERSONATION_USER, session);
}

export function clearImpersonationSession() {
  impersonationSession.value = null;
  SessionStorage.remove(SESSION_STORAGE_KEYS.IMPERSONATION_USER);
}

export function useImpersonation() {
  const isImpersonating = computed(() => Boolean(impersonationSession.value));
  const impersonation = computed(() => impersonationSession.value);

  return { impersonation, isImpersonating };
}
